import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS, TextButton } from 'ui/button';
import { AlertsEmptyState, AlertsZeroState, ErrorStatePageError } from 'ui/illustrations';
import {
  PlaceholderDescription,
  PlaceholderState,
  PlaceholderTitle,
} from 'ui/indexPages/PlaceholderState';
import { LinkButton } from 'ui/linkButton';
import { body2, colors, heading5 } from 'ui/theme';

const StyledPlaceholderState = styled(PlaceholderState)`
  max-width: 282px;
  & ${PlaceholderTitle} {
    ${heading5}
  }

  && ${PlaceholderDescription} {
    ${body2}
    color: ${colors.textSecondary};
  }
`;

const StyledTextButton = styled(TextButton)`
  padding-inline: 0;
`;

const StyledLinkButton = styled(LinkButton)`
  padding-inline: 0;
`;

export const RecentCampaignAlertsErrorState = ({
  refetch,
}: {
  refetch: () => void;
}) => {
  return (
    <StyledPlaceholderState
      Illustration={ErrorStatePageError}
      title="We’ve hit a snag"
      data-test="alerts-error-state"
    >
      Sorry, we’re having trouble loading alerts for this project. Come back again later or{' '}
      <StyledTextButton onClick={refetch} size={BUTTON_SIZES.MEDIUM}>
        try reloading.
      </StyledTextButton>
    </StyledPlaceholderState>
  );
};

export const RecentCampaignAlertsEmptyState = () => {
  return (
    <StyledPlaceholderState
      Illustration={AlertsEmptyState}
      title="Alerts not configured"
      data-test="alerts-empty-state"
    >
      Alerts aren’t configured for this project yet. You can configure alerts on the{' '}
      <StyledLinkButton
        to="/settings/alerts/campaigns"
        variant={BUTTON_VARIANTS.TEXT}
        size={BUTTON_SIZES.MEDIUM}
      >
        alerts settings page.
      </StyledLinkButton>
    </StyledPlaceholderState>
  );
};

export const RecentCampaignAlertsZeroState = () => {
  return (
    <StyledPlaceholderState
      Illustration={AlertsZeroState}
      title="There’s nothing here"
      data-test="alerts-zero-state"
    >
      No alerts have been triggered for this project yet.
    </StyledPlaceholderState>
  );
};
